export default __webpack_public_path__ + "static/media/ban-desktop-image-3.0c38c965.jpg";